import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  orderItem: {
    width: '100%',
    marginBottom: 10,
    padding: 15,
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: theme.colors.dark.midnightBlue,
    borderRadius: 18,
    borderWidth: 1,
    borderStyle: 'solid',
  },
  orderCheck: {
    display: 'flex',
    alignItems: 'center',
  },
  productNamePrice: {
    marginLeft: 10,
  },
  productName: {
    margin: '0 0 5px 0',
    fontSize: 14,
    fontWeight: 900,
    color: theme.colors.light.freshPowder,
  },
  productPrice: {
    margin: 0,
    fontSize: 12,
    color: theme.colors.light.lightCyan,
  },
}));

export const useStylesButton = makeStyles(theme => ({
  root: {
    height: 'auto',
    padding: 16,
    lineHeight: '1',
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.dark.steelBlue,
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
    },
  },
}));
